import { createApp } from 'vue';
import VacationForm from '../components/VacationForm.vue';
import { Modal } from 'flowbite';
import VueConfetti from 'vue-confetti';

export const modals = () => {
  let formApp = null;
  let modal = null;

  const openModalButtons = document.querySelectorAll('.open-modal');

  const openModal = (leaveType) => {
    const modalEl = document.getElementById('vacation-modal');
    console.log('=== OPENING VACATION MODAL ===');
    console.log('leaveType == ', leaveType);
    console.log('Modal element found:', modalEl ? 'Yes' : 'No');

    // Unmount the previous Vue instance if it exists
    if (formApp) {
      formApp.unmount();
      formApp = null;
    }

    // Mount the new Vue instance with the selected leave type
    const formEl = document.getElementById('vacation-form');
    console.log('Form element found:', formEl ? 'Yes' : 'No');
    
    formApp = createApp(VacationForm, {
      preselectedType: leaveType
    });
    formApp.use(VueConfetti); // Add VueConfetti to the modal form
    console.log('Mounting Vue app to #vacation-form');
    formApp.mount('#vacation-form');
    console.log('Vue app mounted successfully');

    // Initialize or show the modal
    if (!modal) {
      modal = new Modal(modalEl);
    }

    modal.show();

    // Handle modal close event
    const closeModalButton = modalEl.querySelector('[data-modal-hide="vacation-modal"]');
    closeModalButton.removeEventListener('click', handleCloseModal);
    closeModalButton.addEventListener('click', handleCloseModal);
  };

  const handleCloseModal = () => {
    if (formApp) {
      formApp.unmount();
      formApp = null;
    }
    if (modal) {
      modal.hide();
    }
  };

  openModalButtons.forEach(button => {
    button.addEventListener('click', function () {
      const leaveType = button.getAttribute('data-leave-type');
      openModal(leaveType);
    });
  });
};
